import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import moment from 'moment';

Vue.use(Vuex);

export const store = new Vuex.Store({
	plugins: [createPersistedState()],
	state:{
		online:true,
		user:null,
		wizard_user:null,
		auth:false,
		time:0,
		dev:false,
		selected_guesthouse:null,
		selected_rooms:null,
		filled_rooms:null,
		arrive_at:null,
		leave_at:null,		
		booking_filter:{
			guesthouse_id:null,
			date:moment().startOf('month').format('YYYY-MM-DD'),
		},
	},
	mutations: {
		updateDev(state,value){
			state.dev = value;
		},
		updateBookingFilter(state,value){
			state.booking_filter = value;
		},
		updateTime(state,value){
			state.time = value;
		},
		updateUser(state,value){
			state.user = value;
		},
		updateWizardUser(state,value){
			state.wizard_user = value;
		},
		updateAuth(state,value){
			console.log('updating value to: '+value)
			state.auth = value;
		},
		updateUserProperty(state,property,value){
			state.user[property] = value;
		},
		updateSignatureModal(state,value){
			state.signature_modal = value;
		},
		updateOnline(state,value){
			state.online = value;
		},
		updateSelectedGuesthouse(state,value){
			state.selected_guesthouse = value;
		},
		updateSelectedRooms(state,value){
			state.selected_rooms = value;
		},
		updateFilledRooms(state,value){
			state.filled_rooms = null;
			state.filled_rooms = value;
		},
		updateArriveAt(state,value){
			state.arrive_at = value;
		},
		updateLeaveAt(state,value){
			state.leave_at = value;
		},
		updateSelectedGuesthousePrices(state,value){
			state.selected_guesthouse.prices = value;
		},
	},
	getters: {
		roleId (state) {
			//console.log('state.user',state.user)
			if(state.user){
				return state.user.role_id;
			}else{
				return null;
			}
		}
	}
});